import { Vector as VectorLayer } from "ol/layer";
import { Vector as VectorSource } from "ol/source";
import { Circle as CircleStyle, Fill, Stroke, Style, Text } from "ol/style";
import { LayerDefaults, LayerTitle } from "../types/layers";
import { readMapSettings } from "./localMapSettings";

interface Return {
  source: VectorSource;
  layer: VectorLayer;
}

function createPortLayer(drawing?: boolean): Return {
  const source = new VectorSource();
  const title = drawing ? LayerTitle.PortsDraw : LayerTitle.Ports;
  const layer = new VectorLayer({
    source,
    zIndex:
      readMapSettings("layers", title)?.zIndex ?? LayerDefaults[title].zIndex,
    visible:
      readMapSettings("layers", title)?.visible ?? LayerDefaults[title].visible,
    style: (feature) => {
      return new Style({
        fill: new Fill({
          color: "rgba(255, 255, 255, 0.2)",
        }),
        stroke: new Stroke({
          color: "#ffcc33",
          width: 2,
        }),
        image: new CircleStyle({
          radius: 7,
          fill: new Fill({
            color: "#ffcc33",
          }),
        }),
        text: new Text({
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          text: feature.get("name") ?? "",
          // Hidden, for now
          scale: 0,
        }),
      });
    },
  });
  layer.set("title", title);

  return { source, layer };
}

export default createPortLayer;
